exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-wave {\n    position: relative;\n    top: 50%;\n    margin: auto;\n    width: 50px;\n    height: 40px;\n    text-align: center;\n    font-size: 10px;\n}\n\n.sk-wave .sk-rect {\n    height: 100%;\n    width: 6px;\n    display: inline-block;\n    animation: sk-waveStretchDelay 1.2s infinite ease-in-out;\n}\n\n.sk-wave .sk-rect1 {\n    animation-delay: -1.2s;\n}\n\n.sk-wave .sk-rect2 {\n    animation-delay: -1.1s;\n}\n\n.sk-wave .sk-rect3 {\n    animation-delay: -1s;\n}\n\n.sk-wave .sk-rect5 {\n    animation-delay: -0.8s;\n}\n\n.sk-wave .sk-rect4 {\n    animation-delay: -0.9s;\n}\n\n@keyframes sk-waveStretchDelay {\n    0%, 40%, 100% {\n        transform: scaleY(0.4);\n    }\n    20% {\n        transform: scaleY(1);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/spinner/spinkit-css/sk-wave.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-wave.css
// module chunks = main